// extracted by mini-css-extract-plugin
module.exports = {"mobile":"_30XlS","root":"_3ki7X","onImage":"_3QWyZ"};